import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                       from '../api/api.service';
import { BigDecimalService }                from '../core/services/big-decimal.service';
import { CustomerPaymentMethodModel }       from './models/customer-payment.method';
import { CustomerPaymentModel }             from './models/customer-payment';
import { CustomerPaymentsMethodsComponent } from './customer-payments.methods.component';

@Injectable({
  providedIn: 'root'
})
export class CustomerPaymentsService {
  constructor (
    private apiService       : ApiService,
    private bigDecimalService: BigDecimalService,
    private modalService     : NgbModal,
  ) {}

  getPayment ( id : string ) : ng.IPromise<CustomerPaymentModel> {
    return this.apiService.get('/customer_payment', id);
  }

  getPosPaymentTotal ( payment : CustomerPaymentModel, isRefund = false ) : string {
    const methodField = isRefund
      ? 'customer_refund_methods_attributes'
      : 'customer_payment_methods_attributes';

    let amount = this.bigDecimalService.get();

    const eftPaymentMethods = payment[ methodField ]
    .filter(( method : CustomerPaymentMethodModel ) => method.use_eftpos);

    if ( eftPaymentMethods.length ) {
      amount  = this.bigDecimalService.get();

      payment[ methodField ].forEach(( method : CustomerPaymentMethodModel ) => {
        const lineAmount = this.bigDecimalService.get(method.amount.toString());

        if ( method.use_eftpos ) {
          amount = amount.add(lineAmount);
        }
      });
    }

    return amount.isZero()
      ? null
      : amount.toString();
  }

  isStatus ( payment : CustomerPaymentModel, status : 'closed' | 'open' = 'open' ) : boolean {
    switch (status) {
      case 'closed':
        return payment.status === 'C';
      case 'open':
      default:
        return payment.status === 'O';
    }
  }

  viewPaymentMethods ( payment : CustomerPaymentModel ) : ng.IPromise<any> {
    const modalRef = this.modalService.open(CustomerPaymentsMethodsComponent);

    modalRef.componentInstance.payment = payment;

    return modalRef.result;
  }
}
